<script>
import FirebaseNodeV3 from '../../base/FirebaseNode'
import Divider from "../../../editor/nodes/Divider.vue";

export default Divider.extend({
  name: "DividerV3",
  mixins: [FirebaseNodeV3],
})
</script>
